import locale from '../locale'
import TabletMenu from '@components/tablet-menu/component'
import MobileMenu from '@components/mobile-menu/component'
import lkHeader from '@modules/shared/ui/lk/header/LkHeader.vue'
import search from '@components/ui-components/search/component'
// import HeaderPromo from '@components/ui-components/header-promo/HeaderPromo.vue'
import LogoAxoftSOFL from '@assets/img/LogoAxoftSOFL.svg?inline'
// новогоднее оформление, пусть пока останется, в будущем можно будет подключить повторно
// import UISnow from './new-year/snow.vue';
// import UIGift from './new-year/gift.vue';
// import UIPuzzle from './new-year/puzzle.vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      submenuVisible: -1,
      submenuVisible2: -1,
      timeout: null,

      openMenuDecisions: -1,
      openMenuDir: -1,
      openClasses: -1,

      eventModalOpened: false,
      regionSlug: null,
    }
  },
  components: {
    locale,
    'tablet-menu': TabletMenu,
    'mobile-menu': MobileMenu,
    'lk-header-cmp': lkHeader,
    'search-cmp': search,
    'logo-axoft-sofl-svg': LogoAxoftSOFL,
    // HeaderPromo,
    // новогоднее оформление, пусть пока останется, в будущем можно будет подключить повторно
    // 'ui-snow': UISnow,
    // 'ui-gift': UIGift,
    // 'ui-puzzle': UIPuzzle,
  },
  async mounted() {
    await this.checkRouteQuery()
  },
  computed: {
    ...mapState('mobile', ['isMobileMenuVisible', 'isTabletMenuVisible', 'isTablet']),
    ...mapGetters('lk', ['isAuth', 'linkAuth', 'linkLogout']),

    isBurgerActive() {
      return this.isMobileMenuVisible || this.isTabletMenuVisible
    },
  },
  watch: {
    '$route.path': function() {
      this.CloseSubmenu()
      this.openMenuDecisions = -1
    },
    '$route.query.modal': async function() {
      await this.checkRouteQuery()
    },
  },
  methods: {
    ...mapActions('modal', ['modalType_collabOpen', 'modalClose', 'modalType_ironPartnerOpen']),
    ...mapMutations('mobile', ['toggleMobileMenu']),

    async checkRouteQuery() {
      if (__AXOFT__.isRU && this.$route.query.modal === 'iron-partner-test') {
        const { modal, ...query } = { ...this.$route.query }

        await this.$router.replace({
          path: this.$route.path,
          query,
          hash: this.$route.hash,
        })

        this.modalType_ironPartnerOpen({ overflowNone: true })
      }
    },

    OpenSubmenu(index, name) {
      if (!this.isTablet) {
        if (name === 'submenuVisible') {
          this.submenuVisible = index
          this.submenuVisible2 = -1
        } else {
          this.submenuVisible2 = index
          this.submenuVisible = -1
        }
        clearTimeout(this.timeout)
      }
    },
    CloseSubmenu() {
      if (!this.isTablet) {
        this.timeout = setTimeout(() => {
          this.submenuVisible = -1
          this.submenuVisible2 = -1
        }, 500)
      }
    },
    openClassDes(index) {
      if (!this.isTablet) {
        this.openClasses = index
        // clearTimeout(this.timeout3);
      }
    },
    // closeClassDes() {
    //     if (!this.isTablet) {
    //         this.timeout3 = setTimeout(() => {
    //             this.openClasses = -1;
    //         }, 500);
    //     }
    // },
    toggleSubmenu(index, name) {
      if (name === 'submenuVisible') {
        this.submenuVisible = this.submenuVisible > -1 ? -1 : index
      } else {
        this.submenuVisible2 = this.submenuVisible2 > -1 ? -1 : index
      }
    },
    clickMenuDecisions(key, index) {
      this.submenuVisible2 = -1
      this.openMenuDecisions = parseInt(key, 10)
      this.openMenuDir = index

      this.openClasses = parseInt(index, 10)
    },
    eventModalOpen() {
      this.eventModalOpened = true
    },
    eventModalClose() {
      this.eventModalOpened = false
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/base/header/component.js